export default {
  props: ['do'],
  name: 'VueClickaway',
  mounted() {
    const listener = e => {
      if (e.target === this.$el || this.$el.contains(e.target)) {
        return
      }
      this.do()
    }

    document.addEventListener('click', listener, false)

    this.$once('hook:beforeDestroy', () => {
      document.removeEventListener('click', listener, false)
    })
  },
  render() {
    return this.$slots.default[0]
  },
}
